import React from 'react';
import Modal from 'react-bootstrap/Modal';
import TextButton from 'components/TextButton';
import CloseIcon from 'resources/Icon-Close-Btn.svg';
import './SuccessAvatarModal.scss';

const SuccessAvatarModal = props => {
  return (
    <Modal
      show={props.showSuccessAvatarModal}
      onHide={() => {
        props.hideSuccessAvatar();
      }}
      className="modal-dialog-success-avatar-modal"
      centered
    >
      <Modal.Body>
        <h2 className="success-avatar-title">SUCCESS</h2>
        <div className="success-avatar-content">
          You have successfully changed your avatar.
        </div>
      </Modal.Body>
      <div className="dialog-close-button">
        <TextButton
          onClick={() => {
            props.hideSuccessAvatar();
          }}
        >
          <img src={CloseIcon} alt="Close Dialog" />
        </TextButton>
      </div>
    </Modal>
  );
};

export default SuccessAvatarModal;
